export default __webpack_public_path__ + "static/media/walker.975c570a.png";